// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import memberAccount from './routes/memberAccount';
import memberRenew from './routes/memberRenew';
import search from './routes/search';

import contactUsBlock from './routes/blocks/contactUs';
import donateBlock from './routes/blocks/donate';
import memberLoginBlock from './routes/blocks/memberLogin';
import memberRegisterBlock from './routes/blocks/memberRegister';
import memberResetpassBlock from './routes/blocks/memberResetpass';
import presentationSubmissionBlock from './routes/blocks/presentationSubmission';
import ticketRegistrationBlock from './routes/blocks/ticketRegistration';
import primaryHeroBlock from './routes/blocks/primaryHero';
import internalMenuBlock from './routes/blocks/internalMenu';
import committeeBlock from './routes/blocks/committee';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,

  // Search page
  search,

  memberAccount,

  memberRenew,

  contactUsBlock,

  donateBlock,

  memberLoginBlock,

  memberRegisterBlock,

  memberResetpassBlock,

  presentationSubmissionBlock,
  
  ticketRegistrationBlock,

  primaryHeroBlock,

  internalMenuBlock,

  committeeBlock,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js